module.exports = __webpack_public_path__ + "static/media/EERI_Banner_3d.e29b3680.png";